import ActionTypes from '../constants/action-types';
import initialState from '../../data/chatGallery';

const chatGalleryReducer = (state = initialState, action) => {
    switch (action.type) {

        case ActionTypes.SET_SHOW_CHAT_GALLERY:
            return {
                ...state,
                show: action.payload,
            };

        case ActionTypes.SET_GET_CHAT_GALLERY_IS_BUSY:
            return {
                ...state,
                isLoading: action.payload,
            };

        case ActionTypes.SET_CHAT_GALLERY_MEDIA:
            return {
                ...state,
                medias: action.payload,
            };

        case ActionTypes.SET_CHAT_GALLERY_FILTER:
            return {
                ...state,
                filter: action.payload,
            };

        case ActionTypes.SET_CHAT_GALLERY_MESSAGES:
            return {
                ...state,
                messages: action.payload,
            };

        case ActionTypes.SET_CHAT_GALLERY_HAS_MORE:
            return {
                ...state,
                hasMore: action.payload,
            };

        case ActionTypes.SET_CHAT_GALLERY_ACTIVE_MESSAGE:
            return {
                ...state,
                activeMessage: action.payload,
            };

        case ActionTypes.SET_CHAT_GALLERY_SOURCE:
            return {
                ...state,
                source: action.payload,
            };

        default: return state;
    }
};

export default chatGalleryReducer;
